export default __webpack_public_path__ + "static/media/Activity14.6924d122.jpeg";